import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCustomerPriceList,
  fetchCustomerPriceListExcel,
} from "../../../services/customerPriceListService";

export const fetchCustomerPriceListThunk = createAsyncThunk(
  "customerPriceList/fetch",
  async ({ customerId, dateFrom, dateTo }, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerPriceList(
        customerId,
        dateFrom,
        dateTo
      );
      return response?.d?.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchCustomerPriceListExcelThunk = createAsyncThunk(
  "customerPriceListExcel/fetch",
  async ({ customerId, dateFrom, dateTo }, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerPriceListExcel(
        customerId,
        dateFrom,
        dateTo
      );
      return response?.d?.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
